exports.BadgeType = {
    DONATION: 'DONATION',
    // Awarded once a user completes a donation goal. `value` on the badge is the
    // number of completed goals required, so tiered goal badges work like donation ones.
    GOAL_COMPLETED: 'GOAL_COMPLETED'
}